type BrandLogoProps = {
  /** Use the mark alone below the `sm` breakpoint to keep navigation usable on small screens. */
  compactOnMobile?: boolean;
  className?: string;
};

export function BrandLogo({ compactOnMobile = false, className = "h-7 w-auto" }: BrandLogoProps) {
  if (!compactOnMobile) {
    return <img src="/brand/neattick-logo.svg" alt="NeatTick" className={className} />;
  }

  return (
    <>
      <img src="/brand/neattick-logo.svg" alt="NeatTick" className={`hidden sm:block ${className}`} />
      <img src="/brand/neattick-mark.svg" alt="NeatTick" className="h-7 w-7 sm:hidden" />
    </>
  );
}
